import { useRef } from "react"

export const useStableComponentId = (componentId?: string) => {
  const idRef = useRef<string>("")

  if (!idRef.current) {
    idRef.current = componentId || `tamda-news-layout-${Date.now()}`
  }

  return idRef.current
}
